angular.module('mx.SolutionBuilderAgent').component('mxRecentItemsPanel', {
	bindings: {},
	controller: MxRecentItemsPanelCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-recent-items-panel/mx-recent-items-panel.html',
});

MxRecentItemsPanelCtrl.$inject = ['mx.shell.SidePanelService', 'mx.SolutionBuilderAgent.RecentService'];

function MxRecentItemsPanelCtrl(sidePanelService, recentService) {
	var vm = this;
	vm.sidePanelService = sidePanelService;
	vm.recentService = recentService;
	return vm;
}
